import React from 'react';

import { Slide, Section, preloader } from 'spectacle-ppa';

import imagePPALogo from '../../images/ppa_presents.svg';
import imageEPSLogo from '../../images/emergencyPreparednessSquadGlow.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './start.md';

const md = new MarkdownScript(markdownFile);

export function preloadStart () {
  preloader([
    imageEPSLogo
  ]);
}

function startSection ({ regionData }) {
  /* Level intro graphic */
  return (
    <Section id="start">

      <Slide
          id="ppa-presents"
          key="ppa-presents"
          bgColor="black"
          notes={md.getSubSectionAsHtml('Assembly Start', 'Notes', false, regionData)}>
        <div
            className="ui-slide">
          <div className="flex-image">
            <img
                className="heading-image heading-image-before"
                src={imagePPALogo} />
          </div>
        </div>
      </Slide>

      <Slide
          id="ppa-eps"
          bgColor="black"
          notes={md.getSubSectionAsHtml('Assembly Start', 'Notes', false, regionData)}>
        <div
            className="ui-slide">
          <div className="flex-image">
            <img className="eps-logo heading-image"
                src={imageEPSLogo} />
          </div>
        </div>
      </Slide>

      {/* Sanksrit for Vanessa */}
      {/* lokah samastah sukhino bhavantu */}
      {/* may all beings everywhere be at peace */}

    </Section>
  );
}

export default startSection;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/sections/02_start/startSection.jsx